import * as yup from 'yup';

const customDigitRegex = /^-?\d+(\.\d)?\d*$/;

const schema = yup.string().matches(customDigitRegex);

export default schema;
